export const VALUATION_OBLIGATION_CHARACTERISTICS = [
  { id: 'NOT_SUBORDINATED', displayValue: 'Not Subordinated' },
  { id: 'SPECIFIED_CURRENCY', displayValue: 'Specified Currency' },
  {
    id: 'SPECIFIED_CURRENCY_STANDARD_SPECIFIED_CURRENCIES',
    displayValue: 'Standard Specified Currencies',
  },
  {
    id: 'SPECIFIED_CURRENCY_STANDARD_SPECIFIED_CURRENCIES_AND_DOMESTIC_CURRENCY',
    displayValue: 'Standard Specified Currencies and Domestic Currency',
  },
  { id: 'NOT_SOVEREIGN_LENDER', displayValue: 'Not Sovereign Lender' },
  { id: 'NOT_DOMESTIC_CURRENCY', displayValue: 'Not Domestic Currency' },
  { id: 'NOT_DOMESTIC_LAW', displayValue: 'Not Domestic Law' },
  { id: 'LISTED', displayValue: 'Listed' },
  { id: 'NOT_DOMESTIC_ISSUANCE', displayValue: 'Not Domestic Issuance' },
  { id: 'ASSIGNABLE_LOAN', displayValue: 'Assignable Loan' },
  { id: 'CONSENT_REQUIRED_LOAN', displayValue: 'Consent Required Loan' },
  {
    id: 'DIRECT_LOAN_PARTICIPATION',
    displayValue: 'Direct Loan Participation',
  },
  { id: 'TRANSFERABLE', displayValue: 'Transferable' },
  { id: 'MAXIMUM_MATURITY', displayValue: 'Maximum Maturity' },
  { id: 'ACCELERATED_OR_MATURED', displayValue: 'Accelerated or Matured' },
  { id: 'NOT_BEARER', displayValue: 'Not Bearer' },
  { id: 'NOT_CONTINGENT', displayValue: 'Not Contingent' },
];
